import './App.css'

function Creatures() {
  return (
    <div className="app">
      {/* Hero Section */}
      <section className="hero">
        <nav className="navbar">
          <div className="logo">
            <a href="/">HEYBUB</a>
          </div>
          <div className="nav-links">
            <a href="/#features">MUSIC</a>
            <a href="/#about">ABOUT</a>
            <a href="/#contact">CONTACT</a>
          </div>
        </nav>
        <div className="hero-content">
          <h1 className="ritchie-title">CREATURES FROM MARS</h1>
          <p className="ritchie-subtitle">THEY'RE COMING FOR YOUR CHILDREN</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="about">
        <div className="about-content">
          <p>Raw energy, no edits.</p>
          <p>Just creatures.</p>
          <p>From Mars.</p>
          <p>Coming soon.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>THE CREATURES ARE COMING...</h4>
            <p>and they want to steal your children</p>
          </div>
          <div className="footer-section">
            <h4>FIND US</h4>
            <p>Email: tim@heybubitstim.com</p>
            <p>Phone: (555) HEY-BUB</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 HEYBUB. ALL RIGHTS RESERVED.</p>
        </div>
      </footer>
    </div>
  )
}

export default Creatures 